export default __webpack_public_path__ + "static/media/lr.4af9961b.svg";